import React, { useMemo } from 'react';
import { Text, UnstyledButton, Image } from '@mantine/core';
import FileIcons from '../../assets/file-icons';
import { ProofOfCompetitorPricing } from '../../codegen/graphql';
import SuperAdminS3Path from '../common/SuperAdminS3Path';
import PropagationStopper from '../common/PropagationStopper';

type Props = {
    proofOfPricing: ProofOfCompetitorPricing;
    openGallery: () => void;
};

function ProofOfPricingCard({ proofOfPricing, openGallery }: Props) {
    const extension = useMemo(() => {
        if (!proofOfPricing?.details?.fileExtension) {
            return 'UNK';
        }
        return proofOfPricing?.details?.fileExtension
            .split('.')
            .pop()
            ?.toUpperCase();
    }, [proofOfPricing]);

    const fileName = useMemo(() => {
        if (!proofOfPricing?.details?.fileName) {
            return 'N/A';
        }
        return proofOfPricing?.details?.fileName;
    }, [proofOfPricing]);

    const fileIcon = useMemo(
        () =>
            FileIcons[
                (extension as keyof typeof FileIcons) ??
                    ('UNK' as keyof typeof FileIcons)
            ] ?? FileIcons.UNK,
        [extension],
    );

    return (
        <UnstyledButton
            component="div"
            onClick={openGallery}
            className="cursor-pointer flex items-center justify-between w-full py-4 px-8 h-20 rounded-md border-solid border border-gray-200 hover:shadow-md text-gray-600 hover:text-primary mb-4 last:mb-0"
        >
            <div className="flex min-w-0 items-center space-x-4">
                <Image
                    w={30}
                    h={30}
                    src={fileIcon}
                    alt={`${fileIcon} Icon`}
                    fit="contain"
                />
                <Text className="text-lg font-semibold truncate">
                    {fileName}
                </Text>
            </div>
            <PropagationStopper>
                <SuperAdminS3Path
                    path={proofOfPricing.documentS3Path}
                    bucket="documents"
                />
            </PropagationStopper>
        </UnstyledButton>
    );
}

export default ProofOfPricingCard;
